module.exports = __webpack_public_path__ + "9de0187156359192be9571702348bbe5.jpg";